module.exports = Symbol.iterator

// typeof Symbol !== 'undefined'
//   ? Symbol.iterator
//   : '@@iterator'

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXRlcmF0b3IuanMiLCJzb3VyY2VzIjpbIml0ZXJhdG9yLmpzIl0sInNvdXJjZXNDb250ZW50IjpbIm1vZHVsZS5leHBvcnRzID0gU3ltYm9sLml0ZXJhdG9yXG5cbi8vIHR5cGVvZiBTeW1ib2wgIT09ICd1bmRlZmluZWQnXG4vLyAgID8gU3ltYm9sLml0ZXJhdG9yXG4vLyAgIDogJ0BAaXRlcmF0b3InXG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFDLE9BQU8sR0FBRyxNQUFNLENBQUMsUUFBUTs7Ozs7In0=